export default __webpack_public_path__ + "static/media/cover-placeholder.e687e253.png";